import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Chapter, MaskLines, Reveal } from "./Reveal";
import { WorldMap } from "./Deco";
import { WEDDING } from "../content";

const calc = () => {
  const diff = new Date(WEDDING.dateISO).getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    mins: Math.floor((diff / 60000) % 60),
    secs: Math.floor((diff / 1000) % 60),
  };
};

export const Countdown = ({ t }) => {
  const [time, setTime] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = time
    ? [
        { v: time.days, l: t.days },
        { v: time.hours, l: t.hours },
        { v: time.mins, l: t.mins },
        { v: time.secs, l: t.secs },
      ]
    : [];

  return (
    <section id="countdown" className="relative leather py-24 sm:py-32 px-5 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.10] flex items-center justify-center">
        <WorldMap className="w-[120%] h-[120%]" color="var(--gold)" />
      </div>
      <div className="relative max-w-4xl mx-auto text-center">
        <Chapter dark>{t.chapter}</Chapter>
        <MaskLines lines={[t.title]} className="gold-text font-serif text-4xl sm:text-6xl leading-tight" />

        {time ? (
          <div className="mt-14 grid grid-cols-4 gap-2 sm:gap-8 max-w-2xl mx-auto">
            {units.map((u, i) => (
              <Reveal key={u.l} delay={i * 0.08}>
                <div className="relative rounded-xl border border-[var(--gold)]/25 bg-[var(--olive)]/40 py-5 sm:py-9 backdrop-blur-sm">
                  <motion.p
                    key={u.v}
                    initial={{ y: -8, opacity: 0.4 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.4 }}
                    className="gold-text font-serif font-bold text-3xl sm:text-7xl leading-none tabular-nums"
                  >
                    {String(u.v).padStart(2, "0")}
                  </motion.p>
                  <p translate="no" className="notranslate font-mono text-[8px] sm:text-xs tracking-[0.15em] sm:tracking-[0.25em] text-[var(--gold)]/70 mt-2 sm:mt-3">
                    {u.l}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        ) : (
          <p className="gold-text font-script text-5xl mt-12">{t.done}</p>
        )}
      </div>
    </section>
  );
};
